<template>
    <div
        :id="id"
        class="WRangeSliderInput"
        :class="{ error }"
    >
        <div class="Inputs">
            <WDebouncedNumberInput
                id="0"
                class="DebouncedInput"
                :value="inputValue[0]"
                :min="min"
                :max="inputValue[1]"
                :placeholder="0"
                name="firstDebouncedInput"
                align="center"
                @input="handleNumberInput"
            />
            <WDebouncedNumberInput
                id="1"
                class="DebouncedInput"
                :value="inputValue[1]"
                :min="inputValue[0]"
                :max="max"
                :placeholder="0"
                name="secondDebouncedInput"
                align="center"
                @input="handleNumberInput"
            />
        </div>
        <WRangeSlider
            id="2"
            v-model="inputValue"
            :min="min"
            :max="max"
            tooltip="none"
            :error="error"
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { generateIdMixin } from '@/mixins'

export default {
    name: 'WRangeSliderInput',

    mixins: [generateIdMixin],
    props: {
        value: VueTypes.arrayOf(Number).isRequired,
        min: VueTypes.number.isRequired,
        max: VueTypes.number.isRequired,
        error: VueTypes.string.def(''),
    },
    computed: {
        inputValue: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value, this.id)
            },
        },
    },
    methods: {
        handleNumberInput ({ id, value }) {
            const newInputValue = [...this.inputValue]
            newInputValue[id] = Number.isNaN(value) ? this.inputValue[id] : value
            this.inputValue = newInputValue
        },
    },
}
</script>

<style lang="scss" scope>
.WRangeSlider {
    margin-bottom: 15px;
    margin-top: 15px;
}

.DebouncedInput {
    width: 50%;
    margin: 0px 7px 0px 7px !important;
}

.Inputs {
    display:flex;
    justify-content: space-between
}
</style>
